export const formatDuration = (dur) => {
    if (!dur)
        return "";
    const dateObj = new Date(dur * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    const formattedTime = `${formatTime(minutes)}:${formatTime(seconds)}`;
    return hours ? `${formatTime(hours)}:${formattedTime}` : formattedTime;
};
const formatTime = (span) => span.toString().padStart(2, "0");
export const safeMediaPlay = (media) => {
    return {
        play: async () => {
            try {
                await media.play();
            }
            catch (error) {
                console.warn("error trying to play media", error);
            }
        },
    };
};
//# sourceMappingURL=utils.js.map